"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player-status" };
const _hoisted_2 = { class: "player-status-bottom" };
const _hoisted_3 = {
    key: 0,
    class: "player-status-timer"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_player_timer = (0, vue_1.resolveComponent)("player-timer");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", {
                class: (0, vue_1.normalizeClass)(_ctx.getLabelAndTimerClasses())
            }, [
                (0, vue_1.createElementVNode)("div", {
                    class: (0, vue_1.normalizeClass)(_ctx.getActionStatusClasses())
                }, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.actionLabel), 1)
                    ])), [
                        [_directive_i18n]
                    ])
                ], 2),
                (_ctx.showTimer)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                        (0, vue_1.createVNode)(_component_player_timer, {
                            timer: _ctx.timer,
                            live: _ctx.liveTimer
                        }, null, 8, ["timer", "live"])
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ], 2)
        ])
    ]));
}
